export const GET_FINANCAS_DATA = 'GET_FINANCAS_DATA';
export const GET_LOCALFORM_DATA = 'GET_LOCALFORM_DATA';
export const GET_VEREADOR_DATA = 'GET_VEREADOR_DATA';
export const SET_ACESSIBILIDADE = 'SET_ACESSIBILIDADE';
export const GET_REQUEST_DATE_DATA = 'GET_REQUEST_DATE_DATA';
